document.addEventListener('DOMContentLoaded', function() {
    const insightsBlocks = document.querySelectorAll('.our-insights');
    
    insightsBlocks.forEach((block, blockIndex) => {
        const cardsContainer = block.querySelector('.our-insights__cards');
        const cards = block.querySelectorAll('.our-insights__card');
        const prevBtn = block.querySelector('.our-insights__nav-prev');
        const nextBtn = block.querySelector('.our-insights__nav-next');
        
        if (!cardsContainer || !cards.length || !prevBtn || !nextBtn) {
            return;
        }
        
        let currentIndex = 0;
        let isAnimating = false;
        
        function isMobile() {
            return window.innerWidth <= 768;
        }
        
        function getCardsToShow() {
            return isMobile() ? 1 : 2;
        }
        
        function positionCards() {
            const cardsToShow = getCardsToShow();
            const mobile = isMobile();
            
            cards.forEach((card, index) => {
                const offset = index - currentIndex;
                
                if (mobile) {
                    const position = offset * 100;
                    card.style.left = `calc(${position}% + ${offset * 16}px)`;
                } else {
                    
                    if (offset === 0) {
                        card.style.left = '0';
                    } else if (offset === 1) {
                        card.style.left = 'calc(50% + 8px)';
                    } else {
                        const position = offset * 50;
                        card.style.left = `calc(${position}% + ${offset * 8}px)`;
                    }
                }
            });
        }
        
        function updateNavigationButtons() {
            const cardsToShow = getCardsToShow();
            const isPrevDisabled = currentIndex === 0 || isAnimating;
            const isNextDisabled = currentIndex + cardsToShow >= cards.length || isAnimating;
            
            prevBtn.disabled = isPrevDisabled;
            nextBtn.disabled = isNextDisabled;
            
            prevBtn.classList.toggle('disabled', isPrevDisabled);
            nextBtn.classList.toggle('disabled', isNextDisabled);
            
            // Update SVG colors based on disabled state
            const prevSvg = prevBtn.querySelector('svg');
            const nextSvg = nextBtn.querySelector('svg');
            if (prevSvg) {
                prevSvg.style.stroke = isPrevDisabled ? '#4A4D53' : '#1E1D28';
            }
            if (nextSvg) {
                nextSvg.style.stroke = isNextDisabled ? '#4A4D53' : '#1E1D28';
            }
        }
        
        function moveNext() {
            if (isAnimating) return;
            
            const cardsToShow = getCardsToShow();
            if (currentIndex + cardsToShow >= cards.length) return;
            
            isAnimating = true;
            currentIndex++;
            
            positionCards();
            updateNavigationButtons();
            
            setTimeout(() => {
                isAnimating = false;
                updateNavigationButtons();
            }, 500);
        }
        
        function movePrev() {
            if (isAnimating) return;
            if (currentIndex === 0) return;
            
            isAnimating = true;
            currentIndex--;
            
            positionCards();
            updateNavigationButtons();
            
            setTimeout(() => {
                isAnimating = false;
                updateNavigationButtons();
            }, 500);
        }
        
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            moveNext();
        });
        
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            movePrev();
        });
        
        window.addEventListener('resize', () => {
            const cardsToShow = getCardsToShow();
            
            if (currentIndex + cardsToShow > cards.length) {
                currentIndex = Math.max(0, cards.length - cardsToShow);
            }
            
            positionCards();
            updateNavigationButtons();
        });
        
        positionCards();
        updateNavigationButtons();
    });
});
